import styled from "styled-components";
import { Steps, Layout, Alert } from "antd";

const { Step } = Steps;
const { Content } = Layout;

export const PageContent = styled(Content)`
  min-height: 100%;
  width: fit-content;
  margin-top: 64px;
  background-color: #1070b6;
  padding: 30px 5%;
  @media (min-width: 750px) {
    width: 100%;
  }
`;

export const FormCard = styled.div`
  background: white;
  padding: 15px 20px 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 0;
  border-radius: 0 0 2px 2px;
`;

export const CardTitle = styled.div`
  font-weight: bolder;
  color: #1070b6;
  background-color: #d3e8ff;
  text-align: left;
  font-size: 25px;
  width: 100%;
  padding: 10px 20px;
  border-radius: 2px 2px 0 0;
  display: flex;
  & .icon {
    margin-right: 20px;
    @media only screen and (max-width: 768px) {
      margin-right: 10px;
    }
  }
`;

export const FormInfo = styled.div`
  font-size: 16px;
  color: #707070;
  text-align: left;
  margin-bottom: 10px;
`;

export const CustomSteps = styled(Steps)`
  margin-right: 0px;
  width: 100%;
  flex-direction: row !important;
  justify-content: space-between;
  & .ant-steps-item-tail::after {
    height: 0px;
  }
  & .ant-steps-item-title {
    color: white !important;
    font-weight: bold;
  }
  & .ant-steps-item-title::after {
    display: none;
  }
  & .ant-steps-item-process .ant-steps-item-icon .ant-steps-icon {
    color: #1070b6;
  }
  @media (max-width: 480px) {
    &.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-content {
      min-height: 0px;
    }
    &.ant-steps-horizontal.ant-steps-label-horizontal
      > .ant-steps-item
      > .ant-steps-item-container
      > .ant-steps-item-tail::after {
      height: 0px;
    }
  }
  @media only screen and (min-width: 992px) {
    margin-left: 50px;
  }
`;

export const CustomStep = styled(Step)`
  width: 33%;
  &.ant-steps-item-title {
    padding-right: 0;
  }
  & .ant-steps-item-icon .ant-steps-icon {
    font-weight: bold;
    top: -2px;
  }
  &.ant-steps-item-process .ant-steps-item-icon {
    background: white;
    border: 2px solid white;
  }
  &.ant-steps-item-active > .ant-steps-item-icon {
    color: white;
    background-color: #1070b6;
  }
  &.ant-steps-horizontal.ant-steps-label-horizontal .ant-steps-item-content {
    margin-right: 0px;
  }
  &.ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    background-color: white;
  }
  &.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-icon {
    background-color: #fbd440;
  }
  &.ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: #fbd440 !important;
  }
  &.ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    display: none;
  }
  &.ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title::after {
    display: none;
  }
`;

export const LinkedText = styled.a`
  color: #1070b6;
  font-weight: bold;
  text-decoration: underline;
`;

export const SuccessMessage = styled(Alert)`
  & .ant-alert-icon {
    color: #389e0d !important;
  }

  & .ant-alert-message,
  & .ant-alert-description {
    color: #389e0d !important;
    font-weight: 500;
    text-align: left;
  }

  & .ant-alert-message {
    font-size: 1.2rem;
  }
`;
export const TextDivider = styled.div`
  color: white;
  font-weight: bold;
  text-align: center;
  font-size: 1.2rem;
  margin: 20px 0;
`;
export const SocialButton = styled(CardTitle)`
  background-color: white;
  cursor: pointer;
  &[aria-disabled="true"] {
    opacity: 0.5;
    cursor: not-allowed;
  }
  font-size: 22px;
  @media only screen and (max-width: 768px) {
    font-size: 20px;
  }
  @media only screen and (min-width: 1400px) {
    font-size: 25px;
  }
`;
export const SocialMediaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
